export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-14.jpg'),
        title: 'エンタープライズモビリティ',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '効率的な業務、コスト削減、社内リソースの統合',
      description: `<p style="font-size:1.05rem">
      近年の技術進展とインターネットの普及に伴い、企業のモバイル化とチャネルのモバイル対応が不可欠になっています。OA、ERP、メール、CRMは企業運営に欠かせないツールです。自社でのアプリ開発はコストと時間がかかるため、アウトソーシングは有効な解決策となります。MaesInfoは12年にわたるエンタープライズ向け運用・保守の経験を持ち、40カ国以上のクライアントのモバイル導入を支援してきました。場所に依存しない安全なモバイル環境を構築し、従業員が任意の場所・デバイスで業務を遂行できるようサポートします。
      </p><p>当社はユーザー体験を最優先に、業務の競争力を強化し、モバイルマーケティングの新モデルを把握し、認証の正確性を確保して企業の安全を守り、モバイルとPCの完璧な連携を実現します。</p>`
    },
    {
      title: '提供サービス例',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-14.jpg')+`)"></span>
      <span class="list">
      <i></i>OA、ERP、CRMシステムの運用・保守サービス<br/>
      <i></i>企業ニーズに応じたカスタムモバイルワークフローとその運用支援


      </span>`
    }
  ]
}
